import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as React from "react";
export default function useThenable(create) {
    var _React_useState = _sliced_to_array(React.useState(create), 1), promise = _React_useState[0];
    var initialState = [
        false,
        undefined
    ];
    // Check if our thenable is synchronous
    promise.then(function(result) {
        initialState = [
            true,
            result
        ];
    });
    var _React_useState1 = _sliced_to_array(React.useState(initialState), 2), state = _React_useState1[0], setState = _React_useState1[1];
    var _state = _sliced_to_array(state, 1), resolved = _state[0];
    React.useEffect(function() {
        var cancelled = false;
        var resolve = function() {
            var _ref = _async_to_generator(function() {
                var result;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                ,
                                2,
                                3
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 1:
                            result = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            if (!cancelled) {
                                setState([
                                    true,
                                    result
                                ]);
                            }
                            return [
                                7
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function resolve() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!resolved) {
            resolve();
        }
        return function() {
            cancelled = true;
        };
    }, [
        promise,
        resolved
    ]);
    return state;
}
